(function () {
  'use strict';

  function initMotoTarp() {

    /* =========================================
       COUPON LOGIC
    ========================================= */

    var couponApplied = false;

    window.applyCoupon = function () {
      var couponInput = document.getElementById('couponCode');

      var couponCode = couponInput
        ? couponInput.value.trim().toUpperCase()
        : '';

      if (couponCode === 'MOTOTARP10') {
        couponApplied = true;

        var priceElement =
          document.getElementById('sumPrice');

        var totalElement =
          document.getElementById('sumTotal');

        var discountElement =
          document.getElementById('discountAmount');

        var discountRow =
          document.getElementById('discountRow');

        if (priceElement && totalElement) {
          var priceText =
            priceElement.textContent.replace(/[^0-9.]/g, '');

          var price =
            parseFloat(priceText);

          if (!isNaN(price)) {
            var discount =
              price * 0.10;

            var total =
              price - discount;

            if (discountElement) {
              discountElement.textContent =
                '-$' + discount.toFixed(2);
            }

            if (discountRow) {
              discountRow.style.display = '';
            }

            totalElement.textContent =
              '$' + total.toFixed(2);
          }
        }

        alert('Coupon applied successfully!');

      } else {

        couponApplied = false;

        alert('Invalid coupon code.');

        var discountRowReset =
          document.getElementById('discountRow');

        if (discountRowReset) {
          discountRowReset.style.display = 'none';
        }
      }
    };


    window.removeCoupon = function () {
      couponApplied = false;

      var discountRow =
        document.getElementById('discountRow');

      if (discountRow) {
        discountRow.style.display = 'none';
      }

      var couponInput =
        document.getElementById('couponCode');

      if (couponInput) {
        couponInput.value = '';
      }

      var priceElement =
        document.getElementById('sumPrice');

      var totalElement =
        document.getElementById('sumTotal');

      if (priceElement && totalElement) {
        var priceText =
          priceElement.textContent.replace(/[^0-9.]/g, '');

        var price =
          parseFloat(priceText);

        if (!isNaN(price)) {
          totalElement.textContent =
            '$' + price.toFixed(2);
        }
      }
    };


    /* =========================================
       MOBILE MENU
    ========================================= */

    window.toggleMenu = function (button) {
      var nav =
        document.getElementById('siteNav');

      if (!nav) {
        return;
      }

      nav.classList.toggle('open');

      if (button) {
        button.classList.toggle('active');
      }
    };


    var navLinks =
      document.querySelectorAll('#siteNav a');

    for (
      var navIndex = 0;
      navIndex < navLinks.length;
      navIndex++
    ) {
      navLinks[navIndex].addEventListener(
        'click',
        function () {
          var nav =
            document.getElementById('siteNav');

          if (nav) {
            nav.classList.remove('open');
          }
        }
      );
    }


    /* =========================================
       SIZE CARDS
    ========================================= */

    var sizeCards =
      document.querySelectorAll('.size-card');

    var checkoutSize =
      document.getElementById('checkoutSize');

    var images = {};

    for (
      var imageIndex = 0;
      imageIndex < sizeCards.length;
      imageIndex++
    ) {
      var card =
        sizeCards[imageIndex];

      var cardSize =
        card.getAttribute('data-size');

      var cardImage =
        card.querySelector('img');

      if (cardSize && cardImage) {
        images[cardSize] =
          cardImage.src;
      }
    }


    window.setSize = function (size) {

      if (!size) {
        return;
      }


      /* Set active size card */
      for (
        var cardIndex = 0;
        cardIndex < sizeCards.length;
        cardIndex++
      ) {
        var currentCard =
          sizeCards[cardIndex];

        var currentSize =
          currentCard.getAttribute('data-size');

        if (currentSize === size) {
          currentCard.classList.add('active');
        } else {
          currentCard.classList.remove('active');
        }
      }


      /* Update dropdown */
      if (checkoutSize) {
        checkoutSize.value = size;
      }


      /* Update summary size */
      var sumSize =
        document.getElementById('sumSize');

      if (sumSize) {
        sumSize.textContent = size;
      }


      /* Find selected card */
      var selectedCard = null;

      for (
        var selectedIndex = 0;
        selectedIndex < sizeCards.length;
        selectedIndex++
      ) {
        if (
          sizeCards[selectedIndex]
            .getAttribute('data-size') === size
        ) {
          selectedCard =
            sizeCards[selectedIndex];

          break;
        }
      }


      if (selectedCard) {

        /* Update usage */
        var useElement =
          selectedCard.querySelector('.size-use');

        var sumUse =
          document.getElementById('sumUse');

        if (useElement && sumUse) {
          sumUse.textContent =
            useElement.textContent;
        }


        /* Update price */
        var priceElement =
          selectedCard.querySelector('.size-price');

        var sumPrice =
          document.getElementById('sumPrice');

        var sumTotal =
          document.getElementById('sumTotal');

        if (priceElement) {

          var priceText =
            priceElement.textContent;

          if (sumPrice) {
            sumPrice.textContent =
              priceText;
          }

          /*
             Only update total directly when
             coupon is NOT currently applied.
          */
          if (
            sumTotal &&
            !couponApplied
          ) {
            sumTotal.textContent =
              priceText;
          }
        }


        /* Update summary image */
        var summaryImage =
          document.getElementById('summaryImage');

        if (
          summaryImage &&
          images[size]
        ) {
          summaryImage.src =
            images[size];
        }


        /* Update sticky section */
        var stickySize =
          document.getElementById('stickySize');

        var stickyPrice =
          document.getElementById('stickyPrice');

        if (stickySize) {
          stickySize.textContent =
            size;
        }

        if (
          stickyPrice &&
          priceElement
        ) {
          stickyPrice.textContent =
            priceElement.textContent;
        }
      }
    };


    /* =========================================
       SIZE CARD CLICK
    ========================================= */

    for (
      var sizeIndex = 0;
      sizeIndex < sizeCards.length;
      sizeIndex++
    ) {
      sizeCards[sizeIndex].addEventListener(
        'click',
        function () {

          var selectedSize =
            this.getAttribute('data-size');

          if (selectedSize) {
            window.setSize(selectedSize);
          }
        }
      );
    }


    /* =========================================
       DROPDOWN CHANGE
    ========================================= */

    if (checkoutSize) {

      checkoutSize.addEventListener(
        'change',
        function () {

          if (this.value) {
            window.setSize(this.value);
          }

        }
      );
    }


    /* =========================================
       DEFAULT LARGE SIZE
    ========================================= */

    if (checkoutSize) {
      checkoutSize.value = 'L';
    }

    window.setSize('L');


    /* =========================================
       RECOMMEND SIZE
    ========================================= */

    window.recommendSize = function () {

      var bikeL =
        document.getElementById('bikeL');

      var bikeW =
        document.getElementById('bikeW');

      var bikeH =
        document.getElementById('bikeH');

      if (
        !bikeL ||
        !bikeW ||
        !bikeH
      ) {
        return;
      }

      var length =
        parseFloat(bikeL.value);

      var width =
        parseFloat(bikeW.value);

      var height =
        parseFloat(bikeH.value);

      if (
        isNaN(length) ||
        isNaN(width) ||
        isNaN(height)
      ) {
        alert(
          'Please enter your bike dimensions.'
        );

        return;
      }


      var recommendedSize = null;

      for (
        var recommendIndex = 0;
        recommendIndex < sizeCards.length;
        recommendIndex++
      ) {

        var recommendCard =
          sizeCards[recommendIndex];

        var maxL =
          parseFloat(
            recommendCard.getAttribute('data-l')
          );

        var maxW =
          parseFloat(
            recommendCard.getAttribute('data-w')
          );

        var maxH =
          parseFloat(
            recommendCard.getAttribute('data-h')
          );

        if (
          length <= maxL &&
          width <= maxW &&
          height <= maxH
        ) {

          recommendedSize =
            recommendCard.getAttribute('data-size');

          break;
        }
      }


      var fitResult =
        document.getElementById('fitResult');

      if (recommendedSize) {

        window.setSize(
          recommendedSize
        );

        if (fitResult) {
          fitResult.textContent =
            'Recommended size: ' +
            recommendedSize;
        }

      } else {

        if (fitResult) {
          fitResult.textContent =
            'Please contact us for help choosing your size.';
        }
      }


      var orderSection =
        document.getElementById('order');

      if (orderSection) {

        orderSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });

      }
    };


    /* =========================================
       SHOPIFY CHECKOUT
    ========================================= */

   window.goToShopifyCheckout = function () {

  var required = [
    'firstName',
    'lastName',
    'email',
    'phone',
    'address',
    'city',
    'region',
    'postal'
  ];

  var missing = [];

  for (var i = 0; i < required.length; i++) {

    var element =
      document.getElementById(required[i]);

    if (
      !element ||
      !element.value.trim()
    ) {
      missing.push(required[i]);
    }
  }

  if (missing.length) {

    alert(
      'Please complete your shipping details before continuing to checkout.'
    );

    return;
  }


  /* =========================================
     SHOPIFY VARIANT IDs
  ========================================= */

  var variantMap = {

    'L': '51359705071904',
    '2XL': '51796598653216',
    '3XL': '51360889438496',
    '4XL': '51360889504032',
    '5XL': '51861734261024',
    '6XL': '52314899644704'

  };


  var selectedSize = '';

  if (checkoutSize) {
    selectedSize = checkoutSize.value;
  }


  var variantId =
    variantMap[selectedSize];


  if (!variantId) {

    alert(
      'Please select a valid cover size before continuing.'
    );

    return;
  }


  /* =========================================
     GET FORM VALUES
  ========================================= */

  var firstName =
    document.getElementById('firstName').value.trim();

  var lastName =
    document.getElementById('lastName').value.trim();

  var email =
    document.getElementById('email').value.trim();

  var phone =
    document.getElementById('phone').value.trim();

  var address =
    document.getElementById('address').value.trim();

  var city =
    document.getElementById('city').value.trim();

  var region =
    document.getElementById('region').value.trim();

  var postal =
    document.getElementById('postal').value.trim();


/* =========================================
   COUNTRY
========================================= */

var countryElement =
  document.getElementById('country');

var country = '';

if (countryElement) {
  country = countryElement.value.trim();
}

console.log('Selected Country:', country);


/* =========================================
   STATE
========================================= */

var stateElement =
  document.getElementById('region');

var state = '';

if (stateElement) {
  state = stateElement.value.trim();
}

console.log('Selected State:', state);


/* =========================================
   ADD COUNTRY TO SHOPIFY CHECKOUT
========================================= */

if (country) {
  checkoutUrl +=
    '&checkout[shipping_address][country]=' +
    encodeURIComponent(country);
}


/* =========================================
   ADD STATE TO SHOPIFY CHECKOUT
========================================= */

if (state) {
  checkoutUrl +=
    '&checkout[shipping_address][province]=' +
    encodeURIComponent(state);
}


console.log('FINAL CHECKOUT URL:', checkoutUrl);
  /* =========================================
     COUPON
  ========================================= */

  var couponInput =
    document.getElementById('couponCode');

  var couponCode = '';

  if (couponInput) {

    couponCode =
      couponInput.value
        .trim()
        .toUpperCase();

  }


  /* =========================================
     CREATE CHECKOUT URL
  ========================================= */

  var checkoutUrl =
    '/cart/' +
    variantId +
    ':1?checkout';


  /*
     Prefill Shopify checkout fields
  */

  checkoutUrl +=
    '&checkout[email]=' +
    encodeURIComponent(email);

  checkoutUrl +=
    '&checkout[shipping_address][first_name]=' +
    encodeURIComponent(firstName);

  checkoutUrl +=
    '&checkout[shipping_address][last_name]=' +
    encodeURIComponent(lastName);

  checkoutUrl +=
    '&checkout[shipping_address][address1]=' +
    encodeURIComponent(address);

  checkoutUrl +=
    '&checkout[shipping_address][city]=' +
    encodeURIComponent(city);

  checkoutUrl +=
    '&checkout[shipping_address][province]=' +
    encodeURIComponent(region);

  checkoutUrl +=
    '&checkout[shipping_address][zip]=' +
    encodeURIComponent(postal);


  /* Country */

  if (country) {

    checkoutUrl +=
      '&checkout[shipping_address][country]=' +
      encodeURIComponent(country);

  }


  /* Phone */

  if (phone) {

    checkoutUrl +=
      '&checkout[shipping_address][phone]=' +
      encodeURIComponent(phone);

  }


  /* =========================================
     APPLY SHOPIFY DISCOUNT
  ========================================= */

  if (couponCode === 'MOTOTARP10') {

    checkoutUrl +=
      '&discount=MOTOTARP10';

  }


  /* =========================================
     REDIRECT
  ========================================= */

  window.location.href =
    checkoutUrl;
};
    /* =========================================
       FIT POPUP
    ========================================= */

    var fitPopup =
      document.getElementById('fitPopup');

    var fitPopupClose =
      document.querySelector(
        '.fit-popup-close'
      );

    if (
      fitPopupClose &&
      fitPopup
    ) {

      fitPopupClose.addEventListener(
        'click',
        function () {
          fitPopup.classList.remove('open');
        }
      );
    }


    /* =========================================
       STICKY BUY BUTTON
    ========================================= */

    var stickyBuy =
      document.getElementById('stickyBuy');

    if (stickyBuy) {

      stickyBuy.addEventListener(
        'click',
        function () {

          var orderSection =
            document.getElementById('order');

          if (orderSection) {

            orderSection.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });

          }
        }
      );
    }


    /* =========================================
       DISCOUNT POPUP
    ========================================= */

    var discountPopup =
      document.getElementById('discountPopup');

    var discountPopupClose =
      document.querySelector(
        '.discount-popup-close'
      );

    if (
      discountPopupClose &&
      discountPopup
    ) {

      discountPopupClose.addEventListener(
        'click',
        function () {
          discountPopup.classList.remove('open');
        }
      );
    }


    /* =========================================
       DISCOUNT TIMER
    ========================================= */

    var timerElement =
      document.getElementById('discountTimer');

    if (timerElement) {

      var countdownTime =
        15 * 60;

      var countdownInterval =
        setInterval(
          function () {

            var minutes =
              Math.floor(
                countdownTime / 60
              );

            var seconds =
              countdownTime % 60;

            timerElement.textContent =
              minutes +
              ':' +
              (seconds < 10 ? '0' : '') +
              seconds;

            countdownTime--;

            if (countdownTime < 0) {

              clearInterval(
                countdownInterval
              );

              timerElement.textContent =
                '0:00';
            }

          },
          1000
        );
    }

  }


  /* =========================================
     INITIALIZE
  ========================================= */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initMotoTarp
    );

  } else {

    initMotoTarp();

  }

})();


(function () {
  /* =========================
     DISCOUNT POPUP + TIMER
  ========================= */
  const DURATION = 15 * 60 * 1000;

  let end = Number(sessionStorage.getItem('mototarpPromoEnd'));

  if (!end || end <= Date.now()) {
    end = Date.now() + DURATION;
    sessionStorage.setItem('mototarpPromoEnd', String(end));
  }

  function fmt(ms) {
    const total = Math.max(0, Math.floor(ms / 1000));
    const m = String(Math.floor(total / 60)).padStart(2, '0');
    const s = String(total % 60).padStart(2, '0');

    return m + ':' + s;
  }

  function tick() {
    const left = end - Date.now();

    document
      .querySelectorAll('[data-promo-timer]')
      .forEach(function (el) {
        el.textContent = fmt(left);
      });

    if (left <= 0) {
      clearInterval(iv);
    }
  }

  tick();

  const iv = setInterval(tick, 1000);


  /* =========================
     DISCOUNT POPUP
  ========================= */
  window.closeDiscountPopup = function () {
    const popup = document.getElementById('discountPopup');

    if (popup) {
      popup.classList.remove('show');
      popup.setAttribute('aria-hidden', 'true');

      sessionStorage.setItem('mototarpPopupSeen', '1');
    }
  };

  function openDiscount() {
    const popup = document.getElementById('discountPopup');

    if (popup) {
      popup.classList.add('show');
      popup.setAttribute('aria-hidden', 'false');
    }
  }

  // Show discount popup after 900ms
  setTimeout(function () {
    if (!sessionStorage.getItem('mototarpPopupSeen')) {
      openDiscount();
    }
  }, 900);

  // Exit intent for discount popup
  document.addEventListener('mouseleave', function (e) {
    if (
      e.clientY <= 0 &&
      !sessionStorage.getItem('mototarpExitShown')
    ) {
      sessionStorage.setItem('mototarpExitShown', '1');
      openDiscount();
    }
  });


  /* =========================
     FIT POPUP
  ========================= */
  let fitPopupShown = false;

  window.showFitPopup = function () {
    if (fitPopupShown) return;

    const popup = document.getElementById('fitPopup');

    if (!popup) return;

    fitPopupShown = true;

    popup.classList.add('show');
    popup.setAttribute('aria-hidden', 'false');
  };

  window.closeFitPopup = function () {
    const popup = document.getElementById('fitPopup');

    if (!popup) return;

    popup.classList.remove('show');
    popup.setAttribute('aria-hidden', 'true');
  };

  // Show fit popup after 22 seconds
  setTimeout(function () {
    if (
      window.scrollY <
      document.body.scrollHeight * 0.55
    ) {
      window.showFitPopup();
    }
  }, 22000);

  // Exit intent for fit popup
  document.addEventListener('mouseout', function (e) {
    if (e.clientY <= 0 && !fitPopupShown) {
      window.showFitPopup();
    }
  });

  // Close fit popup when clicking outside content
  document.addEventListener('click', function (e) {
    const popup = document.getElementById('fitPopup');

    if (popup && e.target === popup) {
      window.closeFitPopup();
    }
  });


  /* =========================
     STICKY BUY BUTTON
  ========================= */
  function syncStickyBuy() {
    const stickyBuy = document.querySelector('.sticky-buy');
    const heroSection = document.querySelector('.hero');

    if (!stickyBuy || !heroSection) return;

    const heroEnd =
      heroSection.offsetTop +
      heroSection.offsetHeight -
      120;

    const shouldShow =
      window.innerWidth <= 980 &&
      window.scrollY > heroEnd;

    stickyBuy.classList.toggle('show', shouldShow);
  }

  window.addEventListener(
    'scroll',
    syncStickyBuy,
    { passive: true }
  );

  window.addEventListener(
    'resize',
    syncStickyBuy
  );

  syncStickyBuy();

})();
